
import { Card } from "@/components/ui/card";
import { Camera } from "lucide-react";

export const MediaSettings = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Media Management</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="aspect-square bg-pink-50 rounded-lg flex items-center justify-center cursor-pointer hover:bg-pink-100 transition-colors">
          <Camera className="w-8 h-8 text-hotbot-pink" />
        </div>
        <div className="aspect-square bg-pink-50 rounded-lg flex items-center justify-center border-2 border-dashed border-pink-200 cursor-pointer hover:bg-pink-100 transition-colors">
          <p className="text-sm text-pink-500">Add New</p>
        </div>
      </div>
    </Card>
  );
};
